type DarwinMockSuggestions = {
  tests: { name: string; values: string[] }[]
  features: string[]
}
/**
 * Values here as shown in Darwin debug modal as suggestions to quickly send mock to server.
 * Otherwise config is used:
 * {@link https://gitlab.skypicker.com/frontend/static-data/-/blob/master/data/darwin/mmb.json}
 */
const darwinMockSuggestions: DarwinMockSuggestions = {
  tests: [],
  features: ["DUMMY_FEATURE", "PRICE_MATCH_GUARANTEE", "DISABLE_REFER_A_FRIEND"],
}

export default darwinMockSuggestions
